import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private valueSource = new BehaviorSubject<number>(0);
  private selectedEnvelopesSource = new BehaviorSubject<any[]>([]);
  private toastDisplayed = new BehaviorSubject<boolean>(false);
  private isEditEnvelope = new BehaviorSubject<boolean>(false);

  currentValue = this.valueSource.asObservable();

  constructor() {}

  updateValue(value: number): void {
    this.valueSource.next(value);
  }

  updateSelectedEnvelopes(envelopes: any[]): void {
    this.selectedEnvelopesSource.next(envelopes);
  }

  getSelectedEnvelopes(): any[] {
    return this.selectedEnvelopesSource.value;
  }

  updateToastInfoLimitDisplay(isShow): void {
    this.toastDisplayed.next(isShow);
  }

  getToastInfoLimitDisplay(): boolean {
    return this.toastDisplayed.value;
  }

  updateIsEditEnvelope(isEdit): void {
    this.isEditEnvelope.next(isEdit);
  }

  getIsEditEnvelope(): boolean {
    return this.isEditEnvelope.value;
  }
}
